import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

class Index extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const siteDescription = data.site.siteMetadata.description
    const projects = data.allContentfulRecord.edges
    const logo = this.props.data.logo
    const tickerItems = this.props.data.allContentfulTickerItems

    return (
      <Layout
        location={this.props.location}
        title={siteTitle}
        description={siteDescription}
        projects={projects}
        logo={logo}
        tickerItems={tickerItems}
      >
        <SEO title="All posts" />
      </Layout>
    )
  }
}

export default Index

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description

      }
    }
    logo: file(relativePath: { eq: "dustworldlogoblack.png" }) {
      childImageSharp {
        fixed(width: 120, height: 120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    allContentfulTickerItems {
      nodes {
        tickerTitle
        tickerContent {
          tickerContent
        }
        createdAt
        link {
          link
        }
      }
    }
    allContentfulRecord {
      edges {
        node {
          title
          producer
          slug
          catalog
          sort
        }
      }
    }
  }
`
